import { useTranslation } from 'react-i18next';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useFetch } from './useFetch';
import { api } from '../api';
import { OrderParamsHookResult } from './useOrderParams';
import { formatDateTime } from '../../../utils/util';

interface OrderParamsFormProps extends OrderParamsHookResult {
    hideCurrency?: boolean;
    hidePeriod?: boolean;
}

export const OrderParamsForm: React.FC<OrderParamsFormProps> = ({
    hideCurrency = false,
    hidePeriod = false,
    currency,     setCurrency,
    periodMon,    setPeriodMon,
    camerasAnalytics, setCamerasAnalytics,
    camerasSimple,   setCamerasSimple,
    newEndDate,
    amount,
    discount,
}) => {    
    const { t } = useTranslation();
    // const { data: balance, } = useFetch<Balance | null>(api.getBalance, null);
    const { data: uniqeCrn, } = useFetch<string[]>(api.getUniqueCrn, []);

    // const onChangePeriodMon = (val: number) => {
    //     console.log('2 balance.endDate',balance?.endDate);
    //     setPeriodMon(val);
    //     // Создаем копию, чтобы не мутировать пропс
    //     const startDate = balance?.endDate ? new Date(balance.endDate) : new Date();
    //     startDate.setMonth(startDate.getMonth() + val);
    //     setNewEndDate(startDate);
    // }

    return (
        <>
            {!hideCurrency && (
            <Box mb={2} mt={4}>
                <FormControl size="small" sx={{ minWidth: 150 }}>
                    <InputLabel>{t('OrderForm.CurrencyLabel')}</InputLabel>
                    <Select
                        value={currency}
                        label={t('OrderForm.CurrencyLabel')}
                        onChange={e => setCurrency(e.target.value)}
                    >
                        {uniqeCrn.map(rec => (
                            <MenuItem key={rec} value={rec}>{rec}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
            )}

            {!hidePeriod && (
            <Box mb={2} mt={4}>
                <TextField
                    label={t('OrderForm.PeriodLabel')}
                    type="number"
                    size="small"
                    inputProps={{ min: 1 }}
                    value={periodMon}
                    // onChange={e => onChangePeriodMon(Number(e.target.value || '0'))}
                    onChange={e => setPeriodMon(Number(e.target.value || '0'))}
                    sx={{ width: 150 }}
                />
            </Box>
            )}

            <Box mb={2} p={2} border={1} borderRadius={2} borderColor="grey.400">
                <Typography variant="subtitle1" mb={2}>
                    {t('OrderForm.CamerasTitle')}
                </Typography>
                <Box mb={2}>
                    <TextField
                        label={t('OrderForm.AnaliticCamerasLabel')}
                        type="number"
                        size="small"
                        inputProps={{ min: 0 }}
                        value={camerasAnalytics}
                        onChange={e => setCamerasAnalytics(Number(e.target.value))}
                        sx={{ width: 150 }}
                    />
                </Box>
                <Box mb={2}>
                    <TextField
                        label={t('OrderForm.SimpleCamerasLabel')}
                        type="number"
                        size="small"
                        inputProps={{ min: 0 }}
                        value={camerasSimple}
                        onChange={e => setCamerasSimple(Number(e.target.value))}
                        sx={{ width: 150 }}
                    />
                </Box>
            </Box>

            <Box my={2}>
                {!hideCurrency && (
                <>
                <Typography variant="h6">
                    {t('OrderForm.TotalAmount', { amount, currency })}
                </Typography>
                <Typography variant="h6">
                    {t('OrderForm.TotalDiscount')} {discount}
                </Typography>
                </>
                )}
                <Typography variant="h6">
                    Послуга діятиме до {formatDateTime(newEndDate)}
                </Typography>
            </Box>
        </>
    );
}
